export const phoneTo = ({phone}) => {
  const phoneNumber = phone?.replace(/[^0-9]/g, '');
  const link = `tel:${phoneNumber || ''}`;
  return link;
}



export const mailTo = ({email,subject,content}) => {
  const encodedSubject = encodeURIComponent(subject || '');
  const encodedContent = encodeURIComponent(content || '');
  const link = `mailto:${email || ''}?subject=${encodedSubject || ''}&body=${encodedContent || ''}`;
  return link;
}

export const smsTo = ({phone,content}) => {
  const phoneNumber = phone?.replace(/[^0-9]/g, '');
  const encodedContent = encodeURIComponent(content || '');
  const link = `sms:${phoneNumber || ''}?body=${encodedContent || ''}`;
  return link;
}